export default class StyleLoader {
	// current theme loaded in the application, default to 'app'
	static theme = 'app';

	/**
	 * Append stylesheet and favicon links in index.html.
	 */
	static loadTheme(callback) {
		const theme = 'adl';

		// set stylesheet link
		this.setStylesheetLink(theme);

		// set favicon link
		this.setFaviconLink(theme);

		// store theme value
		this.theme = theme;

		callback && callback();
	}

	/**
	 * Create a link HTML element.
	 * @param rel {string} The attribute.
	 * @param type {string} The attribute.
	 * @param href {string} The attribute.
	 * @return {HTMLElement}
	 */
	static createLink(rel, type, href) {
		const link = document.createElement('link');

		// set link attributes
		link.rel = rel;
		link.type = type;
		link.href = href;

		return link;
	}

	/**
	 * Search the stylesheet link element.
	 * @param rel {string} The rel attribute.
	 * @param search {string} The search string in the link href.
	 * @param {object|null}
	 */
	static queryLink(rel, search) {
		const links = document.getElementsByTagName('link');

		// locate the default stylesheet link
		for (const link of links) {
			if (link.rel === rel && link.href.indexOf(search) !== -1) {
				return { link, href: link.href };
			}
		}

		return null;
	}

	/**
	 * Set stylesheet-typed link node in index.html.
	 * @param theme {string} The new theme replacing the current theme.
	 */
	static setStylesheetLink(theme) {
		const head = document.getElementsByTagName('head')[0];
		const currentStylesheetLink = this.queryLink(
			'stylesheet',
			`${this.theme}.bundle`
		);
		const currentStylesheetLinkHref = currentStylesheetLink
			? currentStylesheetLink.href.replace(
					`${this.theme}.bundle`,
					`${theme}.bundle`
				)
			: '';
		const stylesheetLink = currentStylesheetLink
			? this.createLink('stylesheet', 'text/css', currentStylesheetLinkHref)
			: null;

		// replace stylesheet link
		if (stylesheetLink) {
			head.appendChild(stylesheetLink);
		}

		if (currentStylesheetLink) {
			head.removeChild(currentStylesheetLink.link);
		}
	}

	/**
	 * Set shortcut-typed link node in index.html.
	 * @param theme {string} The new theme replacing the current theme.
	 */
	static setFaviconLink(theme) {
		const head = document.getElementsByTagName('head')[0];
		const currentFaviconLink = this.queryLink(
			'icon',
			`${this.theme}-favicon.ico`
		);
		const faviconLink = this.createLink(
			'icon',
			'image/x-icon',
			`./${theme}-favicon.ico`
		);

		// add favicon link
		head.appendChild(faviconLink);

		// remove old favicon link
		if (currentFaviconLink) {
			head.removeChild(currentFaviconLink.link);
		}
	}
}
